import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Fetches public site config (e.g. whether online payments are enabled).
export function useConfig() {
  const [config, setConfig] = useState({ payments_enabled: false, deposit: 50, loading: true });

  useEffect(() => {
    let mounted = true;
    api
      .get("/config")
      .then((r) => {
        if (mounted) setConfig({ ...r.data, loading: false });
      })
      .catch(() => {
        if (mounted) setConfig({ payments_enabled: false, deposit: 50, loading: false });
      });
    return () => {
      mounted = false;
    };
  }, []);

  return config;
}
